import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnInit, ElementRef, ViewChildren, AfterViewChecked } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeNode } from '@angular/material/tree';
import { DataService } from 'src/app/services/data.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { ToolOutput } from '../../../models/calculationModels';
import { TreeFlatNode } from '../../../models/templatesModels/tree-flat-node';
import { TreeNode } from '../../../models/templatesModels/tree-node';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-tool',
    templateUrl: './tool.component.html',
    styleUrls: ['./tool.component.scss'],
})
export class ToolComponent implements OnInit, AfterViewChecked {
    @Input() form: UntypedFormGroup;
    @Input()
    set tools(value: ToolOutput[]) {
        this._toolsOutput = value;
        this.createTreeStructure();
    }
    get tools(): ToolOutput[] {
        return this._toolsOutput;
    }
    @ViewChildren(MatTreeNode, { read: ElementRef }) treeNodes: ElementRef[];
    destroy$ = new Subject();

    tooltip_position = 'above';
    isCalculated = false;
    toolsNodeList: TreeNode[];
    hasListener: any[] = [];
    oldHighlight: ElementRef;
    manufactureNode: any;
    selectednode: any;
    private _toolsOutput: ToolOutput[];
    private _transformer = (node: TreeNode, level: number) => {
        return {
            expandable: !!node.children && node.children.length > 0,
            name: node.name,
            id: node.id,
            level: level,
            typeId: node.typeId,
            typeName: node.typeName,
        };
    };
    treeControl = new FlatTreeControl<TreeFlatNode>(
        (node) => node.level,
        (node) => node.expandable
    );
    treeFlattener = new MatTreeFlattener(
        this._transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.children
    );
    treedataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    hasChild = (_: number, node: TreeFlatNode) => node.expandable;

    constructor(
        private dataService: DataService,
        private globalEmittersService: GlobalEmittersService
    ) {}

    ngOnInit(): void {
        this.globalEmittersService.isCalculationHappen.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.isCalculated = value;
        });
        this.globalEmittersService.ToolSelectedId.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            if (value) {
                this.selectednode = this.treeControl.dataNodes.find((x) => x.id == value);
                this.manufactureNode = this.treeControl.dataNodes.find((x) => x.name == this.globalEmittersService?.ManufactureName?.value)?.name;
            }
        });
        this.globalEmittersService.refreshTools.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.selectednode = null;
                this.manufactureNode = null;
                this.globalEmittersService.selectedTools.next(null);
                this.dataService.selectedToolId = null;
                this.dataService.selectedToolName = null;
                this.createTreeStructure();
            }
        });
    }

    ngAfterViewChecked() {
        if (!!document.getElementById(this.dataService.selectedToolId)) {
            if (this.dataService?.selectedToolId) {
                document.getElementById(this.dataService?.selectedToolId).classList.add('background-highlight');
            }
        }
    }

    createTreeStructure() {
        if (this.tools == null) {
            this.tools = [];
        }
        if (this.toolsNodeList == null) {
            this.toolsNodeList = [];
        }

        this.toolsNodeList = [];
        for (var tool of this.tools) {
            let manufacturer = tool.manufacturer.name;

            if (this.toolsNodeList.find((x) => x.name == manufacturer)) {
                this.toolsNodeList.find((x) => x.name == manufacturer).children.push({ name: tool.name, id: tool.id });
            } else {
                this.toolsNodeList.push({ name: manufacturer, children: [{ name: tool.name, id: tool.id }] });
            }
        }
        if (this.toolsNodeList.length > 0) {
            this.treedataSource.data = this.toolsNodeList;
            if (this.manufactureNode && this.selectednode) {
                if (this.selectednode) this.SelectedTool(this.selectednode);
                //this.treeControl.expand(this.manufactureNode);
                this.treeControl.dataNodes.forEach((currentValue, index) => {
                    if (currentValue.name == this.manufactureNode) {
                        this.treeControl.expand(this.treeControl.dataNodes[index]);
                    }
                });
            }
        } else {
            this.treedataSource.data = [];
        }
    }

    SelectedTool(node) {
        this.treeNodes.forEach((reference) => {
            reference.nativeElement.classList.remove('background-highlight');
        });
        this.form.get('toolSelected').setValue(node.id);
        this.dataService.selectedToolId = node.id;
        this.dataService.selectedToolName = node.name;
        this.globalEmittersService.selectedTools.next(node.id);
        let selectedToolInfo: ToolOutput = this.tools.find((x) => x.id == node.id);
        this.globalEmittersService.SelectedToolData.next(selectedToolInfo);
        this.globalEmittersService.isToolSelected.next(true);
    }
}
